import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LeftOutlined } from "@ant-design/icons";
import { RightOutlined } from "@ant-design/icons";

import "./TutorReview.css";
import { TutorReviews } from "../../constants";

function getRandomRGBColor() {
  const r = Math.floor(Math.random() * 256);
  const g = Math.floor(Math.random() * 256);
  const b = Math.floor(Math.random() * 256);
  return `rgba(${r}, ${g}, ${b},.35)`;
}

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        left: "0px",
        zIndex: 2,
        top: "50%",
        transform: "translateY(-50%)",
      }}
      onClick={onClick}
    >
      <LeftOutlined style={{ fontSize: "24px", color: "#000" }} />
    </div>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        right: "-18px",
        zIndex: 2,
        top: "50%",
        transform: "translateY(-50%)",
      }}
      onClick={onClick}
    >
      <RightOutlined style={{ fontSize: "24px", color: "#000" }} />
    </div>
  );
};

const TutorsReviewComponent = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 2500,
    // arrows: true,
    // nextArrow: <NextArrow />,
    // prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="updated-slider-container">
      <Slider {...settings}>
        {TutorReviews.map((review, index) => (
          <div className="updated-slider-item-container">
            <div className="updated-card-container" style={{ backgroundColor: getRandomRGBColor() }}>
              <div className="updated-slider-card-main">
                <div className="updated-slider-card-title">{review.reviewTitle}</div>
                <div className="updated-slider-card-desc">{review.content}</div>
              </div>

              <div className="updated-slider-card-footer">
                <div className="updated-slider-card-img-wrapper">
                  <img src={review.image} alt="tutor-img" />
                </div>
                <div className="updated-slider-card-customer-info">
                  <div className="updated-slider-card-customer-name">{review.name}</div>
                  <div className="updated-slider-card-location">{review.location}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default TutorsReviewComponent;
